import { useRef } from 'react';

import { openModal } from '@src/reduce/modals';
import { Button, Checkbox, DatePicker, Input, message } from 'antd';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';

import { ReactComponent as DateIcon } from '@assets/icons/date-suffix.svg';
import { ReactComponent as MapIcon } from '@assets/icons/map.svg';

import { Row } from '../../EditPushCategoryModal/styled';
import { FormProps } from '../type';
import * as S from './styled';

const FormAttend = ({
  formData,
  setFormData,
  hasInitialFormData,
  isEditable,
}: // initialFileName,
FormProps) => {
  const {
    title,
    content,
    date,
    endDate,
    address,
    detailAddress,
    maxCount,
    host,
    manager,
    blockNotSincereMember,
    delegable,
    location,
  } = formData;

  const dispatch = useDispatch();

  const disabled = hasInitialFormData && !isEditable;

  return (
    <S.Container>
      <S.Item>
        <p>
          행사명 <span style={{ color: '#FF0000' }}>*</span>
        </p>
        <Input
          required
          placeholder='행사명을 입력하세요'
          disabled={disabled}
          value={title}
          onChange={({ target: { value } }) => {
            setFormData({ ...formData, title: value });
          }}
        />
      </S.Item>
      <S.Item>
        <p>
          일시 <span style={{ color: '#FF0000' }}>*</span>
        </p>
        <div>
          <DatePicker.RangePicker
            placeholder={['시작일시', '종료일시']}
            format='YYYY-MM-DD HH:mm'
            disabled={disabled}
            suffixIcon={<DateIcon />}
            showTime
            value={[date ? dayjs(date) : null, endDate ? dayjs(endDate) : null]}
            onChange={e => {
              setFormData({
                ...formData,
                date: !!e && !!e[0] ? dayjs(e[0]).format('YYYY-MM-DD HH:mm') : '',
                endDate: !!e && !!e[1] ? dayjs(e[1]).format('YYYY-MM-DD HH:mm') : '',
              });
            }}
          />
          {/* <DatePicker
            placeholder='시작일시'
            format='YYYY-MM-DD'
            disabled={disabled}
            suffixIcon={<DateIcon />}
            value={date ? dayjs(date) : undefined}
            onChange={e => {
              setFormData({ ...formData, date: !e ? '' : dayjs(e).format('YYYY-MM-DD') });
            }}
          />{' '}
          <span className='tilde'>~</span>
          <DatePicker
            placeholder='종료일시'
            format='YYYY-MM-DD'
            disabled={disabled}
            suffixIcon={<DateIcon />}
            value={endDate ? dayjs(endDate) : undefined}
            onChange={e => {
              setFormData({ ...formData, endDate: !e ? '' : dayjs(e).format('YYYY-MM-DD') });
            }}
          /> */}
        </div>
      </S.Item>
      <S.Item>
        <p>
          주최 <span style={{ color: '#FF0000' }}>*</span>
        </p>
        <Input
          placeholder='주최를 입력하세요'
          disabled={disabled}
          value={host}
          onChange={({ target: { value } }) => {
            setFormData({ ...formData, host: value });
          }}
        />
      </S.Item>
      <S.Item>
        <p>
          담당자 <span style={{ color: '#FF0000' }}>*</span>
        </p>
        <Input
          placeholder='행사 담당자를 입력하세요'
          disabled={disabled}
          value={manager}
          onChange={({ target: { value } }) => {
            setFormData({ ...formData, manager: value });
          }}
        />
      </S.Item>
      <S.Item className='items'>
        <p>
          행사장 위치 <span style={{ color: '#FF0000' }}>*</span>
        </p>
        <Input
          required
          placeholder='행사장 위치를 입력하세요'
          disabled={disabled}
          value={address}
          suffix={<MapIcon />}
          onFocus={e => {
            dispatch(openModal({ name: 'postcodeModal', props: { setFormData } }));
          }}
          style={{ borderRadius: '16px' }}
        />
      </S.Item>
      <S.Item>
        <p></p>
        <Input
          placeholder='상세주소를 입력하세요'
          disabled={disabled}
          value={detailAddress}
          onChange={({ target: { value } }) => {
            setFormData({ ...formData, detailAddress: value });
          }}
        />
      </S.Item>
      <S.Item>
        <p>출석 인원수</p>
        <Input
          placeholder='출석 인원수를 입력하세요'
          disabled={disabled}
          value={maxCount ? maxCount : ''}
          onChange={({ target: { value } }) => {
            setFormData({ ...formData, maxCount: parseInt(value) });
          }}
        />
      </S.Item>
      <S.Item className='textarea'>
        <p>
          행사 내용 <span style={{ color: '#FF0000' }}>*</span>
        </p>
        <Input.TextArea
          required
          disabled={disabled}
          value={content}
          onChange={({ target: { value } }) => {
            setFormData({ ...formData, content: value });
          }}
        />
      </S.Item>

      <S.Item className='checkBox'>
        <p>추가 기능</p>
        <div>
          <Checkbox
            checked={delegable}
            onChange={({ target: { checked: value } }) => {
              console.log(value);
              setFormData({ ...formData, delegable: value });
            }}>
            출석 위임 가능
          </Checkbox>
          <Checkbox
            checked={blockNotSincereMember}
            onChange={({ target: { checked: value } }) => {
              console.log(value);
              setFormData({ ...formData, blockNotSincereMember: value });
            }}>
            성실회원만 출석 가능
          </Checkbox>
        </div>
      </S.Item>
    </S.Container>
  );
};

export default FormAttend;
